import { defineComponent as _defineComponent } from 'vue';
import { useDebounce, useDraggable, useElementBounding } from "@vueuse/core";
import { computed, onMounted, ref, watch } from "vue";
import { useEmit } from "@/composables/eventEmitter";
import { useClamp } from "@/composables/math";
import { useAnimationFrameThrottle } from "@/composables/throttle";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DraggableSeparator',
    props: {
        position: null,
        min: { default: 0 },
        max: { default: Infinity },
        showDelay: { default: 100 },
        keyboardStepSize: { default: 50 },
        side: null,
        inner: { type: Boolean, default: false }
    },
    emits: ["positionChanged", "visibilityChanged", "dragging"],
    setup(__props, { emit }) {
        const props = __props;
        const { throttle } = useAnimationFrameThrottle();
        const draggable = ref(null);
        const positionedParent = ref(null);
        onMounted(() => {
            var _a, _b;
            positionedParent.value = (_b = (_a = draggable.value) === null || _a === void 0 ? void 0 : _a.offsetParent) !== null && _b !== void 0 ? _b : null;
        });
        const rootBoundingBox = useElementBounding(positionedParent);
        const { position: draggablePosition, isDragging } = useDraggable(draggable, {
            preventDefault: true,
            exact: true,
            initialValue: { x: props.position, y: 0 },
        });
        useEmit(isDragging, emit, "dragging");
        const handlePosition = useClamp(ref(props.position), () => props.min, () => props.max);
        useEmit(handlePosition, emit, "positionChanged");
        watch(() => props.position, () => (handlePosition.value = props.position));
        const borderWidth = 6;
        function updatePosition() {
            if (props.side === "left") {
                handlePosition.value = draggablePosition.value.x - rootBoundingBox.left.value + borderWidth;
            }
            else {
                const clientWidth = document.body.clientWidth;
                const rootRightDistance = document.body.clientWidth - rootBoundingBox.right.value;
                handlePosition.value = clientWidth - draggablePosition.value.x - rootRightDistance - borderWidth;
            }
        }
        watch(() => draggablePosition.value, () => throttle(updatePosition));
        const hoverDraggable = ref(false);
        const hoverDraggableDebounced = useDebounce(hoverDraggable, computed(() => props.showDelay));
        const showHover = computed(() => (hoverDraggable.value && hoverDraggableDebounced.value) || isDragging.value);
        useEmit(showHover, emit, "visibilityChanged");
        function onKeyLeft() {
            handlePosition.value -= props.keyboardStepSize;
        }
        function onKeyRight() {
            handlePosition.value += props.keyboardStepSize;
        }
        const style = computed(() => ({
            "--position": handlePosition.value + "px",
        }));
        return { __sfc: true, props, emit, throttle, draggable, positionedParent, rootBoundingBox, draggablePosition, isDragging, handlePosition, borderWidth, updatePosition, hoverDraggable, hoverDraggableDebounced, showHover, onKeyLeft, onKeyRight, style };
    }
});
